import { useQuery } from 'react-query';
import axios from 'axios';

// item 237 (reworked) — the current user's favorited contact ids, so the sidebar can pin
// those customers to the top (per-user).
const useMyFavoriteContacts = () => useQuery('contactFavorites', async (): Promise<string[]> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}contacts/favorites`);
  return data?.contactIds ?? [];
});

export default useMyFavoriteContacts;
